import React, { useEffect, useContext } from 'react'
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import LinkIcon from '@mui/icons-material/Link';
import {DatasContext} from '../datas/DatasContext';
import HoverPopover from './HoverPopover';

export default function Header() {

  const {identity} = useContext(DatasContext)
  const menu = identity.menus.mainMenu;

  useEffect(() => {
      scrollDirection()
  }, [])

  return (
  <>
      <a className="hidden skip-a screen-reader-text" href="#content">Skip to content</a>
      <header key="main-header" role="banner" className="main-header h-auto transition-all duration-500 fixed left-4 w-auto z-[1000]">
        <Box sx={{ '& > :not(style)': { m: 1 } }}>
          <HoverPopover title={`${menu[0].title}`} subTitle={menu[0].href}>
            <Fab href={menu[0].href} target="_blank" color="default" size="small" sx={{height:"36px",width:"36px",boxShadow:"unset"}} aria-label={`${menu[0].title}`}>
              <LinkIcon fontSize="small" sx={{transform:"rotate(-45deg)"}} />
            </Fab>
          </HoverPopover>
        </Box>
      </header>
  </>
  )
}

function scrollDirection() {
  
      const offset = 32

      window.addEventListener('load', () => {
          if(window.scrollY > offset) {
              document.body.classList.add('scroll-up')
              document.body.classList.remove('scroll-down')
          } else {
            document.body.classList.add('scroll-offset')
          }
      })
      
      let lastScrollTop = 0

      window.addEventListener('scroll', function() {
        if (window.scrollY > lastScrollTop ) {
          document.body.classList.add('scroll-down')
          document.body.classList.remove('scroll-up')
          
        } else {
          document.body.classList.add('scroll-up')
          document.body.classList.remove('scroll-down') 
        }
  
        if(window.scrollY <= offset) {
          document.body.classList.add('scroll-offset')
        } else {
          document.body.classList.remove('scroll-offset')
        }
  
        lastScrollTop = window.scrollY
      })
   
  }